import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { DEFAULT_SESSION_DIALOG_LIFE, DEFAULT_SESSION_TIME } from '../constants/app.constants';
import { createIdleTimeoutWorker } from '../workers/create-idle-timeout-worker';
import { UIService } from './ui.service';

@Injectable({
  providedIn: 'root',
})
export class IdleTimeoutService {
  private readonly debug = 0;
  private readonly uiService = inject(UIService);

  private worker: Worker | undefined;

  public showSessionDialog$ = new BehaviorSubject<boolean>(false);
  public dialogCountdown$ = new BehaviorSubject<number>(DEFAULT_SESSION_DIALOG_LIFE);

  // Nový subject pro signalizaci události odhlášení
  public logoutRequested$ = new Subject<void>();

  private sessionTime: number;
  private warningThreshold: number;

  constructor() {
    const environment = this.uiService.environmentService.environment;
    this.sessionTime = environment?.defaultSessionTime ?? DEFAULT_SESSION_TIME;
    this.warningThreshold = environment?.defaultSessionDialogLife ?? DEFAULT_SESSION_DIALOG_LIFE;

    if (typeof Worker !== 'undefined') {
      this.worker = createIdleTimeoutWorker();
      // stav jde do BehaviorSubject čtených přes async pipe, takže změnu vykreslí i bez zone.js
      this.worker.onmessage = ({ data }) => {
        this.log(`📩 Přijata zpráva z workeru:`, data, 2);

        if (data.action === 'showDialog') {
          this.log(`✅ Nastavuji showSessionDialog$ na true`);
          this.showSessionDialog$.next(true);
        }

        if (data.action === 'updateDialogTime') {
          this.dialogCountdown$.next(data.remainingTime);
        }

        if (data.action === 'logout') {
          this.logout();
        }
      };
    }
  }

  startInactivityTimer() {
    // this.stopInactivityTimer();
    const countdownTime = (this.sessionTime - this.warningThreshold) * 1000;
    if (this.worker) {
      this.worker.postMessage({ action: 'start', countdownTime, dialogTime: this.warningThreshold });
    }
  }

  stopInactivityTimer() {
    this.showSessionDialog$.next(false);
    if (this.worker) {
      this.worker.postMessage({ action: 'stop' });
    }
  }

  extendSession() {
    this.worker?.postMessage({ action: 'extendSession' });
    this.showSessionDialog$.next(false);
  }

  logout() {
    this.showSessionDialog$.next(false);
    this.log('Uživatel byl odhlášen.');
    // Místo volání authService.logout() emitujeme událost
    this.logoutRequested$.next();
  }

  log(msg: string, object?: any, level = 1) {
    if (this.debug >= level) {
      if (object) {
        console.log(msg, object);
      } else {
        console.log(msg);
      }
    }
  }
}
